import bfInput from './bf-input.vue';
bfInput.install = Vue => Vue.component(bfInput.name,bfInput);
export default bfInput;



// WEBPACK FOOTER //
// ./src/packages/input/index.js